import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Spinner } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import supabase from '../supabaseClient';
import ErrorBoundary from '../components/ErrorBoundary';
import AddRecipeModal from '../components/AddRecipeModal';
import MyFavorites from '../components/MyFavorites';
import MyRecipes from '../components/MyRecipes';

const MyRecipesPage = () => {
    const navigate = useNavigate();
    const { pgUser } = useAuth();
    const [isAuthLoading, setIsAuthLoading] = useState(true);
    const [showAddRecipeModal, setShowAddRecipeModal] = useState(false);
    const [addRecipeError, setAddRecipeError] = useState(null);
    const { sessionToken } = useAuth();

    const handleRecipeAdded = () => {
        setShowAddRecipeModal(false);
        window.location.reload(); // Refresh to show new recipe
    };

    const handleAddRecipeError = (errorMessage) => {
        setAddRecipeError(errorMessage);
    };

    // Handle auth loading state
    useEffect(() => {
        if (pgUser === null) {
            setIsAuthLoading(false);
            return;
        }
        setIsAuthLoading(false);
    }, [pgUser]);

    return (
        <ErrorBoundary fallbackMessage="Unable to load your recipes. Please try again later.">
            <div className="container">
                {isAuthLoading ? (
                    <div className="text-center my-4">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : !pgUser ? (
                    <div className="alert alert-warning">
                        <p className="h5 mb-3">Unable to connect to the server. Please try again later or send a message to <a href="mailto:support@getautochef.com">support@getautochef.com</a></p>
                        <Button onClick={() => window.location.reload()}>Retry</Button>
                    </div>
                ) : (
                    <>
                        
                        <div className="text-center">
                            <h1>My Recipes</h1>
                            <div className="mt-3 mb-1">
                                <Button 
                                    variant="primary"
                                    onClick={() => setShowAddRecipeModal(true)}
                                >
                                    Create Recipe
                                </Button>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center">
                            <MyRecipes sessionToken={sessionToken} />
                        </div>
                        <hr />
                        <div className="text-center">
                            <h1 className="mt-3" style={{ marginBottom: '0px' }}>Favorites</h1>
                        </div>
                        <div className="d-flex justify-content-center">
                            <MyFavorites sessionToken={sessionToken} />
                        </div>
                        
                    </>
                )}

                        {addRecipeError && (
                            <div className="alert alert-danger mt-3">
                                {addRecipeError}
                            </div>
                        )}
                        <AddRecipeModal 
                            isOpen={showAddRecipeModal} 
                            onClose={() => {
                                setShowAddRecipeModal(false);
                                setAddRecipeError(null);
                            }}
                            onSuccess={handleRecipeAdded}
                            onError={handleAddRecipeError}
                        />
            </div>
        </ErrorBoundary>
    );
};

export default MyRecipesPage;
